<template>
	<div class="Apply-Slot">
		  <slot></slot>
      <ApplyButton @refreshButton="refreshButton" @saveData="saveData" :applyButton="value" :buttonShowType="buttonShowType" @maskShow="maskShow=false"></ApplyButton>
			<!-- 遮罩层 -->
			<div id="Mask" :class="(value.status == 1 || value.status == 2 || value.status == 4) && maskShow ? 'Mask-True':''">
				
			</div>
	</div>
</template>

<script>
import ApplyButton from '@/components/Apply-Button'
import ApplySlotGroup from '@/components/Apply-Slot-Group'
export default {
	name:  '',
	components: {
		ApplyButton,
		ApplySlotGroup
	},
	// 定义属性
	data() {
		return {	
			maskShow: true
		}
	},
	// 计算属性，会监听依赖属性值随之变化
	computed: {},
	// 监控data中的数据变化
	watch: {},
	// 方法集合
	methods: {
		saveData(_data) {
			this.$emit('saveData',_data)
		},
		refreshButton() {
			this.$emit('refreshButton')
            this.$forceUpdate();
		},
	},
	props: ['value','buttonShowType'],
	// 生命周期 - 创建完成（可以访问当前this实例）
	created() {
		
	},
	// 生命周期 - 挂载完成（可以访问DOM元素）
	mounted() {
		console.log('slot',this.value)
		if ((this.value.status == 1 || this.value.status == 2 || this.value.status == 4) && this.maskShow) {
			if (this.value.status == 4 || this.value.status == 1) {
        this.$Watermark.set("审核中")
			} else {
			  this.$Watermark.set("审核通过")
			}
		}
	},
	beforeCreate() {}, // 生命周期 - 创建之前
	beforeMount() {}, // 生命周期 - 挂载之前
	beforeUpdate() {}, // 生命周期 - 更新之前
	updated() {}, // 生命周期 - 更新之后
	beforeDestroy() {}, // 生命周期 - 销毁之前
	destroyed() {}, // 生命周期 - 销毁完成
	activated() {}, // 如果页面有keep-alive缓存功能，这个函数会触发
}
</script>

<style scoped lang="scss">
	.Apply-Slot {
		position: relative;
	}
	.Mask-True {
		position: absolute;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
		opacity: 0.2;
		z-index: 1008;
	}
</style>